import React from 'react';
import { Tag } from 'antd';

import { AGENT_BASE_URL } from 'config';

const AgentTraceLink = ({ traceId }) => {
  if (!traceId) return null;

  return (
    <a
      href={`${AGENT_BASE_URL.replace(/\/$/, '')}/traces/${traceId}`}
      target="_blank"
      rel="noopener noreferrer"
    >
      <Tag color="geekblue" title="View the addison-agent classification trace for this image">
        TRACE
      </Tag>
    </a>
  );
};

export default AgentTraceLink;
